import { useMemo } from 'react';
import { Controller } from 'react-hook-form';

import Select, { createSelectCollection, SelectProps } from 'ui/Select';

import { useSankeyFormContext } from '../../contexts/sankeyFormContext';

type Props = Omit<Partial<SelectProps>, 'form'> & {
  field: SankeyFormOptionsField;
  options: SelectOption<any>[];
};

const FormSelect = ({ field: name, options, ...props }: Props) => {
  const { form } = useSankeyFormContext();
  const collection = useMemo(() => createSelectCollection(options), [options]);

  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field }) => (
        <Select
          id={name}
          name={name}
          value={field.value ? [field.value] : []}
          onValueChange={({ value }) => field.onChange(value[0])}
          onInteractOutside={() => field.onBlur()}
          collection={collection}
          {...props}
        />
      )}
    />
  );
};

export default FormSelect;
